
import { defuFn } from '/home/jcwl/project/roncoo-education-web/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "SENTRY_DSN": ""
}



export default /* #__PURE__ */ defuFn(inlineConfig)
